@if (!rootSettlementProductPlans) {
  <skeletons [defaultSkeletons]="5" />
}
@if (rootSettlementProductPlans) {
  <div class="panel-section">
    <ng-container *ngTemplateOutlet="settlementProductPlansList; context:{ settlementProductPlans: rootSettlementProductPlans, selectable: selectable, clickable: clickable }" />
  </div>
}

<ng-template #settlementProductPlansList  let-settlementProductPlans="settlementProductPlans" let-parentList="parentList" let-parent="parent" let-selectable="selectable ?? true">
  <list-view #listView [referenceName]="parentList ? 'childs-to-' + parent : 'main'" [parentList]="parentList" [selectable]="selectable">
    <header [sortColumn]="false">{{ 'settlement.plan-column-header.product-name' | translate }}</header>
    <header [sortColumn]="false" defaultSort="descending">{{ 'settlement.plan-column-header.end-date' | translate }}</header>
    <header [sortColumn]="false" align-right>{{ 'settlement.plan-column-header.plan-amount-open' | translate }}</header>
    <header [sortColumn]="false" align-right>{{ 'settlement.plan-column-header.settlement-amount' | translate }}</header>
    @if (showIncludeVat) {
      <header [sortColumn]="false" align-right>{{ 'settlement.plan-column-header.settlement-amount-incl-vat' | translate }}</header>
    }
    <row *listData="let plan from settlementProductPlans"
      [highlighted]="plan == activeSettlementProductPlan"
      [select]="plan == activeSettlementProductPlan"
      [statusTitle]="plan.statusTitle ? (plan.statusTitle | translate) : null"
      [showCollapseIcon]="true"
      [clickable]="clickable"
      (action)="selectPlan(plan)">
      <column>{{ plan.productPlan | productName }}</column>
      <column [sortValue]="plan.endDate ? plan.endDate : plan.productPlan.accountingPlan?.endDate">{{ (plan.endDate ? plan.endDate : plan.productPlan.accountingPlan?.endDate) | customDate: 'shortDate' }}</column>
      <column align-right>{{ openAmount(plan.productPlan.accountingPlan!) | currency }}</column>
      <column align-right>{{ plan.amount | currency }}</column>
      @if (showIncludeVat) {
        <column align-right>{{ addVat(plan.amount) | currency }}</column>
      }
      @if (childrenPlans[plan.productPlanId] && childrenPlans[plan.productPlanId].length > 0) {
        <ng-container *ngTemplateOutlet="settlementProductPlansList; context:{ settlementProductPlans: childrenPlans[plan.productPlanId], parentList: listView, parent: plan.productPlanId }" />
      }
    </row>
  </list-view>
</ng-template>
